/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AccountWidgetSettingResponse,
  CommonResponseDto,
  HTTPValidationError,
  WidgetSettingUpdateRequestDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 계정의기본위젯세팅을가져오는API
 * @summary GetAccountSetting
 */
export const getAccountSetting = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<AccountWidgetSettingResponse>(
      {url: `/setting/`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAccountSettingQueryKey = () => {
    return [`/setting/`] as const;
    }

    
export const getGetAccountSettingQueryOptions = <TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountSettingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountSetting>>> = ({ signal }) => getAccountSetting(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountSettingQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountSetting>>>
export type GetAccountSettingQueryError = HTTPValidationError


export function useGetAccountSetting<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountSetting>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountSetting<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountSetting>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountSetting<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountSetting
 */

export function useGetAccountSetting<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountSettingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAccountSettingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountSettingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountSetting>>> = ({ signal }) => getAccountSetting(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountSettingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountSetting>>>
export type GetAccountSettingSuspenseQueryError = HTTPValidationError


export function useGetAccountSettingSuspense<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountSettingSuspense<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountSettingSuspense<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountSetting
 */

export function useGetAccountSettingSuspense<TData = Awaited<ReturnType<typeof getAccountSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountSettingSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 계정의기본위젯세팅을수정하는API
 * @summary UpdateAccountSetting
 */
export const updateAccountSetting = (
    widgetSettingUpdateRequestDto: WidgetSettingUpdateRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/setting/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: widgetSettingUpdateRequestDto
    },
      options);
    }
  


export const getUpdateAccountSettingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountSetting>>, TError,{data: WidgetSettingUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountSetting>>, TError,{data: WidgetSettingUpdateRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountSetting>>, {data: WidgetSettingUpdateRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateAccountSetting(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountSettingMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountSetting>>>
    export type UpdateAccountSettingMutationBody = WidgetSettingUpdateRequestDto
    export type UpdateAccountSettingMutationError = HTTPValidationError

    /**
 * @summary UpdateAccountSetting
 */
export const useUpdateAccountSetting = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountSetting>>, TError,{data: WidgetSettingUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountSetting>>,
        TError,
        {data: WidgetSettingUpdateRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateAccountSettingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    